import { IApplicationContext } from '@helpers/types';

const useApplicationContextProvider = (): IApplicationContext => {
  return {};
};
export default useApplicationContextProvider;
